import { withLDProvider } from 'launchdarkly-react-client-sdk'

const FlagProvider = ({ children }: { children: JSX.Element }) => children

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_KEY ?? '',
})(FlagProvider) as typeof FlagProvider
